import apiService from "./apiService";
import AppConstants from "../appConstants";

class TranslationConfigService {
    getAllTranslationConfigs(params = new URLSearchParams()) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_TRANSLATION_CONFIG, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getTranslationConfigDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_TRANSLATION_CONFIG}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerTranslationConfig(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_TRANSLATION_CONFIG, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updateTranslationConfig(id, form, params) {
        return new Promise((resolve, reject) => {
            apiService.put(`${AppConstants.URL_TRANSLATION_CONFIG}/${id}`, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteTranslationConfig(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_TRANSLATION_CONFIG}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    saveAllTranslationConfigs(data, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_TRANSLATION_CONFIG_SAVE_ALL, data, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}

export default new TranslationConfigService();
